<!--大用户 - 大用户数据分析 - 用水分析 -->
<template>
  <div>
    <a-row :gutter="16">
      <a-col :span="8">
        <a-card>
          <div class="card">
            <img src="~@/assets/bigusers/picture/u59.png" class="picture" alt="大用户总数">
            <div class="databox">
              <span>{{ statisticsData.bigUserCount }}</span>
              <span>大用户总数</span>
            </div>
          </div>
        </a-card>
      </a-col>
      <a-col :span="8">
        <a-card>
          <div class="card">
            <img src="~@/assets/bigusers/picture/u64.png" class="picture" alt="机械表用户">
            <div class="databox">
              <span>{{ statisticsData.jiXieBiao }}</span>
              <span>机械表用户</span>
            </div>
          </div>
        </a-card>
      </a-col>
      <a-col :span="8">
        <a-card>
          <div class="card">
            <img src="~@/assets/bigusers/picture/u74.png" class="picture" alt="远传表用户">
            <div class="databox" style="border-right: 1px solid #d3dbcd; height:55px; padding-right: 30px;">
              <span>{{ statisticsData.yuanChuanBiao }}</span>
              <span>远传表用户</span>
            </div>
            <div class="databox fontsize">
              <span>{{ statisticsData.system }}</span>
              <span>系统推送</span>
            </div>
            <div class="databox fontsize">
              <span>{{ statisticsData.manufacturers }}</span>
              <span>实时推送</span>
            </div>
          </div>
        </a-card>
      </a-col>
    </a-row>

    <a-card style="margin-top: 20px;">
      <div>
        <!-- 移除 :labelCol 和 :wrapperCol，让内部的 <a-form-item> 自己决定布局 -->
        <a-form>
          <!-- 第一行：用户编码、用户名称、水表编号、用水性质 -->
          <a-row :gutter="16">
            <a-col :md="6" :sm="12">
              <a-form-item label="用户编码" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                <a-input v-model="query.userCode" placeholder="请输入用户编码" allow-clear style="width: 100%;" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="用户名称" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                <a-input v-model="query.userName" placeholder="请输入用户名称" allow-clear style="width: 100%;" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="水表编号" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                <a-input v-model="query.waterMeterNumber" placeholder="请输入水表编号" allow-clear style="width: 100%;" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="用水性质" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
                <a-select v-model="query.waterType" placeholder="请选择用水性质" allow-clear style="width: 100%;">
                  <a-select-option :value="1">居民用水</a-select-option>
                  <a-select-option :value="2">非居民用水</a-select-option>
                  <a-select-option :value="3">特种用水</a-select-option>
                  <a-select-option :value="4">其他用水</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <!-- 第二行：单独放“时长”，占满一行 -->
          <a-row :gutter="16">
            <a-col :md="12" :sm="24"> <!-- 关键：占满整行 24 栅格 -->
              <a-form-item label="时长" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                <a-radio-group button-style="solid" v-model="timeModel" @change="changeTime">
                  <a-radio-button value="-1">今天</a-radio-button>
                  <a-radio-button value="1">昨天</a-radio-button>
                  <a-radio-button value="7">近7天</a-radio-button>
                  <a-radio-button value="15">近15天</a-radio-button>
                  <a-radio-button value="30">月度</a-radio-button>
                  <a-radio-button value="90">季度</a-radio-button>
                  <a-radio-button value="365">年度</a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>

          <!-- 第三行：查询时间 + 查询按钮 -->
          <a-row :gutter="16">
            <a-col :md="6" :sm="24">
              <a-form-item label="查询时间" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <a-range-picker style="width: 204px;" v-model="queryTime" />
                <a-button type="primary" style="margin-left: 10px;" @click="onQuery">查询</a-button>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="对比时间" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                <a-range-picker style="width: 204px;" v-model="comparisonTime" />
                <a-button type="primary" style="margin-left: 10px;" @click="onQuery">对比</a-button>
              </a-form-item>
            </a-col>
            <!-- 如果有重复的查询时间，建议删除一个 -->
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card style="margin-top: 20px;" v-show="userType == null">
      <div class="empty-container">
        <a-empty description="请输入查找条件" />
      </div>
    </a-card>

    <a-card style="margin-top: 20px;" v-show="userType == 1">
      <div class="chartbox">
        <div ref="waterChart1" style="height: 400px; width: 1536px;"></div>
      </div>
    </a-card>

    <a-card style="margin-top: 20px;" v-show="userType == 2">
      <a-row :gutter="16">
        <a-col :md="12" :sm="12">
          <div class="chartbox">
            <div ref="waterChart2" style="height: 400px; width: 768px;"></div>
          </div>
        </a-col>
        <a-col :md="12" :sm="12">
          <div class="chartbox">
            <div ref="accumulationChart" style="height: 400px; width: 768px; "></div>
          </div>
        </a-col>
        <a-col :md="24" :sm="12" style="margin-top: 20px;">
          <div ref="instantaneousChart" style="height: 400px; width: 1536px;"></div>
        </a-col>
      </a-row>
    </a-card>
  </div>
</template>

<script>
import moment from 'moment'
export default {

  data () {
    return {
      mainTimeRange: [],
      compareTimeRange: [],
      totalConsumption: null,
      query: {
        userCode: '',
        userName: '',
        waterMeterNumber: '',
        waterType: undefined,
      },
      waterChart: null, //用水统计图实例
      accumulationChart: null, //累积量统计图实例
      instantaneousChart: null, //瞬时流量统计图实例

      queryTime: [], //查询时间
      comparisonTime: [], //对比时间
      userType: null, //用水类型
      //查询对象
      timeModel: '-1',
      //接口
      statisticsUrl: '/smart-water-major-users/major/users/user/group/select/count', //统计接口
      queryUrl: '/smart-water-major-users/major/users/user/select/user/manufacturer/',
      //数据
      statisticsData: {},
      //统计图标准样式
      waterStyle: [
        { name: '用水量', type: 'bar', barWidth: '30%', itemStyle: { color: '#389fff' }, barGap: 1 },
        { name: '对比水量', type: 'bar', barWidth: '30%', itemStyle: { color: '#4cca73' }, barGap: 0 }
      ],
      accumulationStyle: [
        { name: '累积量', type: 'line', areaStyle: {}, itemStyle: { color: '#876bfa' }, smooth: true },
        { name: '对比累积量', type: 'line', areaStyle: {}, itemStyle: { color: '#437ae6' }, smooth: true }
      ],
      instantaneousStyle: [
        { name: '瞬时流量', type: 'line', itemStyle: { color: '#389fff' } },
        { name: '对比流量', type: 'line', itemStyle: { color: '#4cca73' } }
      ]
    }
  },
  mounted () {
    // 接收路由参数
    this.getRouteParams();
    this.initData();
  },

  methods: {
    //设置页面名称
    setSystemName () {
      this.$store.commit('SET_SYSTEMNAME', `${this.$store.getters.userInfo.realName}用水分析`)
    },
    // 获取路由参数
    getRouteParams () {
      // 接收参数前先设置查询时间

      // 获取 query 参数
      const userCode = this.$route.query.userCode;
      if (userCode) {
        console.log('接收到的用户ID:', userCode);
        // 将用户ID设置到查询条件中
        this.query.userCode = userCode;
        this.timeModel = '90'
        this.changeTime();
        // 可以在这里自动执行查询
        this.onQuery();
      }
    },

    initData () {
      this.getStatistics();
    },
    //创建用水量柱状图
    initWaterChart (xTime, yData, chartDom) {
      // 先判断是否已经存在一个 ECharts 实例，避免重复初始化
      if (this.waterChart) {
        this.waterChart.dispose(); // 销毁旧的图表实例
      }
      this.waterChart = echarts.init(chartDom);
      const option = {
        title: {
          text: '用水量',
          left: 'left',
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold'
          }
        },
        //鼠标悬停时出现弹窗
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: function (params) {
            let result = ` ${params.map(item => `${item.data.time}：${item.value}m³`).join('<br/>')}`;
            return result.replace(/\s+/g, ' ').trim();
          },
        },
        //图例说明
        legend: {
          data: ['用水量', '对比水量'],
          bottom: 0,
          icon: 'rect',
          itemHeight: 8,
          itemWidth: 8,
        },
        //调整绘图区域与容器的边距
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          // name: '日期',
          data: xTime,
          axisLabel: {}
        },
        yAxis: {
          type: 'value',
          // name: '用水量',
          min: 0,
          splitLine: { // 控制横向网格线
            lineStyle: {
              type: 'dashed', // 设置为虚线
              color: '#ccc',  // 虚线颜色
              width: 1        // 线宽
            }
          },
          axisLine: { show: false }
        },
        series: yData
      };
      this.waterChart.setOption(option);
    },
    //创建用累积量折线图
    initAccumulationChart (xTime, yData) {
      const chartDom = this.$refs.accumulationChart;
      // 先判断是否已经存在一个 ECharts 实例，避免重复初始化
      if (this.accumulationChart) {
        this.accumulationChart.dispose(); // 销毁旧的图表实例
      }
      this.accumulationChart = echarts.init(chartDom);
      const option = {
        title: {
          text: '累积量',
          left: 'left',
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold'
          }
        },
        //鼠标悬停时出现弹窗
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let result = ` ${params.map(item => `${item.data.time}：${item.value}m³`).join('<br/>')}`;
            return result.replace(/\s+/g, ' ').trim();
          }
        },
        //图例说明
        legend: {
          data: ['累积量', '对比累积量'],
          bottom: 0,
          icon: 'rect',
          itemHeight: 8,
          itemWidth: 8,
        },
        //调整绘图区域与容器的边距
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          // name: '日期',
          data: xTime,
          axisLabel: {}
        },
        yAxis: {
          type: 'value',
          min: 0,
          splitLine: { // 控制横向网格线
            lineStyle: {
              type: 'dashed', // 设置为虚线
              color: '#ccc',  // 虚线颜色
              width: 1        // 线宽
            }
          },
          axisLine: { show: false }
        },
        series: yData
      };
      this.accumulationChart.setOption(option);
    },
    //创建用瞬时流量折线图
    initInstantaneousChart (xTime, yData) {
      const chartDom = this.$refs.instantaneousChart;
      // 先判断是否已经存在一个 ECharts 实例，避免重复初始化
      if (this.instantaneousChart) {
        this.instantaneousChart.dispose(); // 销毁旧的图表实例
      }
      this.instantaneousChart = echarts.init(chartDom);
      const option = {
        title: {
          text: '瞬时流量',
          left: 'left',
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold'
          }
        },
        //鼠标悬停时出现弹窗
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            let result = ` ${params.map(item => `${item.data.time}：${item.value}m³`).join('<br/>')}`;
            return result.replace(/\s+/g, ' ').trim();
          }
        },
        //图例说明
        legend: {
          data: ['瞬时流量', '对比流量'],
          bottom: 0,
          icon: 'rect',
          itemHeight: 8,
          itemWidth: 8,
        },
        //调整绘图区域与容器的边距
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          // name: '日期',
          data: xTime,
          axisLabel: {}
        },
        yAxis: {
          type: 'value',
          min: 0,
          splitLine: { // 控制横向网格线
            lineStyle: {
              type: 'dashed', // 设置为虚线
              color: '#ccc',  // 虚线颜色
              width: 1        // 线宽
            }
          },
          axisLine: { show: false }
        },
        series: yData
      };
      this.instantaneousChart.setOption(option);
    },
    //接口调用
    //统计用水数接口
    getStatistics () {
      this.$http.get(this.statisticsUrl).then((res) => {
        console.log(res);
        this.statisticsData = res.data
      })
    },
    //选择时长
    changeTime () {
      // 获取当前日期字符串，比如 "2024-06-01" （确保是 YYYY-MM-DD）
      const currentDateStr = this.getCurrentDate();
      // 安全转换为数字，默认为 0 避免 NaN 导致错误
      const daysToSubtract = isNaN(Number(this.timeModel)) ? 0 : Number(this.timeModel);
      // 当前日期对象
      const currentDate = new Date(currentDateStr);
      // 目标日期对象：减去 daysToSubtract 天
      const targetDate = new Date(currentDate);
      targetDate.setDate(currentDate.getDate() - daysToSubtract);
      // 判断是否为 -1，决定顺序
      this.queryTime = daysToSubtract === -1
        ? [moment(currentDate), moment(targetDate)]  // [今天, 某天前]
        : [moment(targetDate), moment(currentDate)]; // [某天前, 今天]
    },
    //获取当前年月
    getCurrentDate () {
      return new Date().toISOString().split('T')[0];
    },
    // 获取查询参数的方法
    getQueryParams () {
      const params = {
        userCode: this.query.userCode,
        userName: this.query.userName,
        waterMeterNumber: this.query.waterMeterNumber,
        waterType: this.query.waterType,
      };

      // 添加时间参数
      if (this.queryTime && this.queryTime.length === 2) {
        params.collectionTimeBegin = this.queryTime[0].format('YYYY-MM-DD');
        params.collectionTimeEnd = this.queryTime[1].format('YYYY-MM-DD');
      }
      if (this.comparisonTime && this.comparisonTime.length === 2) {
        params.comparisonCurrentIssueTimeBegin = this.comparisonTime[0].format('YYYY-MM-DD');
        params.comparisonCurrentIssueTimeEnd = this.comparisonTime[1].format('YYYY-MM-DD');
      }
      return params;
    },
    //查询用户数据
    onQuery () {
      const params = this.getQueryParams();
      // ====== 先校验必填项：查询时间 ======
      if (!params.collectionTimeBegin && !params.collectionTimeEnd) {
        this.$message.warning('请选择查询时间');
        return;
      } else if (!(params.userCode?.trim() ||
        params.userName?.trim() ||
        params.waterMeterNumber?.trim() ||
        params.waterType)) {
        this.$message.warning('请至少填写一项查询条件');
        return;
      }

      console.log('查询参数:', params);
      this.$http.get(this.queryUrl, { params }).then((res) => {
        if (res.data.length == 0) {
          this.$message.warning('该条件下无数据');
          return;
        }
        if (res.data.length <= 2) {
          this.processingUserData(res.data);
        } else {
          this.processingFactoryData(res.data);
        }
      }).catch(err => {
        console.log("catch: ", err);
        this.userType = null;
      })
    },
    processingUserData (data) {
      console.log('处理普通用户数据');
      this.userType = 1;
      let xTime = []
      let yData = []
      data.forEach(item => {
        let timeList = [];
        let numList = []; //y轴数据
        item.list.forEach(queryData => {
          timeList.push(queryData.selectTime);
          numList.push({
            value: queryData.num,
            time: queryData.selectTime
          });
        })
        //获取x轴数据
        if (item.type == 'userWaterCountSelect') {
          xTime = timeList;
          yData.push(
            {
              ...this.waterStyle[0],
              data: numList,
            }
          )
        } else {
          yData.push(
            {
              ...this.waterStyle[1],
              data: numList,
            }
          )
        }
      });
      this.initWaterChart(xTime, yData, this.$refs.waterChart1);
    },
    processingFactoryData (data) {
      console.log('处理厂商推送数据');
      this.userType = 2;

      // 初始化各个类型的数据容器
      const timeData = {
        useWaterSelect: [],     // 用水量 - 主轴时间
        useWaterComparison: [], // 用水量 - 对比时间（如果有）
        totalSelect: [],        // 累积量 - 主轴时间
        totalComparison: [],    // 累积量 - 对比时间
        instantSelect: [],      // 瞬时流量 - 主轴时间
        instantComparison: [],  // 瞬时流量 - 对比时间
      };

      const chartData = {
        useWater: [],   // 用水量数据集
        total: [],      // 累积量数据集
        instantaneous: [] // 瞬时流量数据集
      };

      // 遍历每一组数据
      data.forEach(item => {
        const xValues = [];
        const yValues = [];

        // 提取当前 item.list 中的时间和数值
        item.list.forEach(queryData => {
          if (queryData && queryData.selectTime !== undefined && queryData.num !== undefined) {
            xValues.push(queryData.selectTime);
            yValues.push({
              value: queryData.num,
              time: queryData.selectTime
            });
          }
        });

        const xTime = xValues;
        const yNums = yValues;

        // 根据 type 分类处理
        switch (item.type) {
          case 'useWaterSelect':
            timeData.useWaterSelect = xTime;
            chartData.useWater.push({ ...this.waterStyle[0], data: yNums });
            break;
          case 'useWaterComparison':
            chartData.useWater.push({ ...this.waterStyle[1], data: yNums });
            break;
          case 'totalSelect':
            timeData.totalSelect = xTime;
            chartData.total.push({ ...this.accumulationStyle[0], data: yNums });
            break;
          case 'totalComparison':
            chartData.total.push({ ...this.accumulationStyle[1], data: yNums });
            break;
          case 'instantSelect':
            timeData.instantSelect = xTime;
            chartData.instantaneous.push({ ...this.instantaneousStyle[0], data: yNums });
            break;
          case 'instantComparison':
            chartData.instantaneous.push({ ...this.instantaneousStyle[1], data: yNums });
            break;
          default:
            // 未知 type，可以选择记录日志或者忽略
            console.warn(`未知的数据类型: ${item.type}`);
            break;
        }
      });

      // 初始化图表，只传入对应的主轴时间
      this.initWaterChart(timeData.useWaterSelect, chartData.useWater, this.$refs.waterChart2);
      this.initAccumulationChart(timeData.totalSelect, chartData.total);
      this.initInstantaneousChart(timeData.instantSelect, chartData.instantaneous);
    },

  },



}


</script>

<style scoped lang="less">
.card {
  display: flex;
  align-items: center;
}

.picture {
  height: 60px;
  width: 60px;
  border-radius: 50%;
  display: block;
  /* 确保图片比例正确 */
  object-fit: cover;
  margin-left: 25px;
}

.databox {
  display: flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: 25px;
  text-align: right;
}

.databox span:first-child {
  display: block;
  font-size: 20px;
  font-weight: bold;
}

.fontsize span:first-child {
  display: block;
  font-size: 17px;
  font-weight: bold;
  text-align: center;
}

.fontsize span:last-child {
  display: block;
  font-size: 13px;
  text-align: center;
}

.time-filter {
  margin-bottom: 12px;
  padding-left: 40px;
  display: flex;
  align-items: center;
  color: #b399b3
}

.time-filter>button {
  /* 右侧负边距 */
  margin-right: -1px;
  /* 左侧负边距 */
  margin-left: -1px;
  border-right: 0;
  border-color: #d9d9d9 !important;

  /* color: #b399b3 !important; */
}

.first-button {
  border-radius: 5px 0 0 5px !important;
}

.last-button {
  border-radius: 0 5px 5px 0 !important;
  border-right: 1px solid #d9d9d9 !important;
}

.date-bar {
  margin-top: 25px;
  margin-left: 10px;
}

.date-bar>button {
  border-radius: 5px;
  width: 80px;
}

.chartbox {
  width: 100%;
  /* 确保它占满父容器宽度 */
  padding: 0;
  /* 避免内边距影响内部 div 的 100% */
  margin: 0;
  /* 避免外边距干扰 */
  box-sizing: border-box;
  /* 推荐：让 padding 和 border 不增加总宽度 */
}

.empty-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  /* 卡片内容区域高度，按需调整 */
}
</style>
